import React from "react";

/*
    For Redux, importing connect and action
    Redux connect is to access Redux states
    Redux actions to update the Redux states
*/
import { connect } from "react-redux";
import { updateForm } from "../../../store/actions/FormAction";
/*
    This page is using a template DashboardLayout
*/
import DashboardLayout from '../../../containers/DashboardLayout';
import ChangePassword from './ChangePassword';
import MyAccount from './MyAccount';
import Profile from './Profile';
import Application from './Application';
import Documents from './Documents';
import Reloan from './Reloan';
import PaymentSchedule from './PaymentSchedule';
import LoanHistory from './LoanHistory';
import LoanAgreements from './LoanAgreements';
import PrivacyPolicy from './documents/PrivacyPolicy';
import EConsent from './documents/EConsent';
import LoanDocs from './documents/LoanDocs';
import Arbitration from './documents/Arbitration';

/*
    Dashboard view that displays the Dashboard pages
    Use router instead?
    TODO: Nedd to add logged in check
*/
class Dashboard extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      view: this.props.match.params.pg
    };
  }
  /*
      Switching between views based on URL param
  */
  render() {
    switch (this.state.view){
      case "viewaccount":
      case "myaccount":
        this.props.updateForm("indefault", false);
        return (
        <DashboardLayout>
          <MyAccount />
        </DashboardLayout>
        );
      case "default":
        this.props.updateForm("indefault", true);
        this.props.updateForm("status", "Default");
        return (
        <DashboardLayout>
          <MyAccount />
        </DashboardLayout>
        );
      case "delinquent":
        this.props.updateForm("indefault", true);
        this.props.updateForm("status", "Delinquent");
        return (
        <DashboardLayout>
          <MyAccount />
        </DashboardLayout>
        );
      case "ppo":
        this.props.updateForm("status", "Pending Paid Off");
        return (
        <DashboardLayout>
          <MyAccount />
        </DashboardLayout>
        );
      case "defaultpif":
        this.props.updateForm("status", "Default SIF/PIF");
        return (
        <DashboardLayout>
          <MyAccount />
        </DashboardLayout>
        );
      case "ineligible":
        this.props.updateForm("eligible", false);
        this.props.updateForm("status", "Withdrawn");
        return (
        <DashboardLayout>
          <MyAccount />
        </DashboardLayout>
        );
      case "withdrawn":
      case "eligible":
        this.props.updateForm("eligible", true);
        this.props.updateForm("status", "Withdrawn");
        return (
        <DashboardLayout>
          <MyAccount />
        </DashboardLayout>
        );
      case "closed":
        this.props.updateForm("status", "Closed");
        return (
        <DashboardLayout>
          <MyAccount />
        </DashboardLayout>
        );
      case "originated":
        this.props.updateForm("status", "Originated");
        return (
        <DashboardLayout>
          <MyAccount />
        </DashboardLayout>
        );
      case "pending":
        this.props.updateForm("status", "Pending");
        return (
        <DashboardLayout>
          <MyAccount />
        </DashboardLayout>
        );
      case "fasttrack":
      case "fasttracked":
        this.props.updateForm("status", "Fast Tracked");
        return (
        <DashboardLayout>
          <MyAccount />
        </DashboardLayout>
        );
      case "recommended":
        this.props.updateForm("status", "Recommended For Approval");
        return (
        <DashboardLayout>
          <MyAccount />
        </DashboardLayout>
        );
      case "paidoff":
        this.props.updateForm("status", "Paid Off");
        return (
        <DashboardLayout>
          <MyAccount />
        </DashboardLayout>
        );
      case "profile":
      case "viewprofile":
      case "myprofile":
        return (
        <DashboardLayout>
          <Profile />
        </DashboardLayout>
        );
      case "application":
        return (
        <DashboardLayout>
          <Application />
        </DashboardLayout>
        );
      case "reloan":
        return (
        <DashboardLayout>
          <Reloan />
        </DashboardLayout>
        );
      case "documents":
        return (
        <DashboardLayout>
          <Documents />
        </DashboardLayout>
        );
      case "paymentschedule":
        return (
        <DashboardLayout>
          <PaymentSchedule />
        </DashboardLayout>
        );
      case "loanhistory":
        return (
        <DashboardLayout>
          <LoanHistory />
        </DashboardLayout>
        );
      case "loanagreement":
        return (
        <DashboardLayout>
          <LoanAgreements />
        </DashboardLayout>
        );
      case "econsent":
        return (
        <DashboardLayout>
          <EConsent />
        </DashboardLayout>
        );
      case "privacypolicy":
        return (
        <DashboardLayout>
          <PrivacyPolicy />
        </DashboardLayout>
        );
      case "loandocs":
        return (
        <DashboardLayout>
          <LoanDocs />
        </DashboardLayout>
        );
      case "arbitrationagreement":
        return (
        <DashboardLayout>
          <Arbitration />
        </DashboardLayout>
        );
      case "changepassword":
        return (
        <DashboardLayout>
          <ChangePassword />
        </DashboardLayout>
        );
      default:
        return (
          <DashboardLayout>
            There was a problem loading the page. Please give us a call.
          </DashboardLayout>
        );
    }
  }
}

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = (dispatch) => ({
    updateForm: (stateType, value) => dispatch(updateForm(stateType, value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);



// WEBPACK FOOTER //
// ./src/components/views/Dashboard/index.js